import { CloseModalIcon, IconLeftArrow } from '../../../../../../components/buttons/IconButtons';
import React from 'react';
import CustomChip from '../../../../../../components/CustomChip';
import { useTranslation } from 'react-i18next';
import {statusBorderColor, statusColor, statusFontColor} from '../../../../../../enums/statusColorEnum';
import {status} from '../../../../../../enums/statusEnum';
import {EMPTY_VALUES} from '../../../../../../Apis/functions';
import {getItemStatusFines} from '../../../Model/Model';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const ComponentHeaderBack = (
    {
        onHide=null, title, classNameTitle = "fs-24px ibl-font-w-600 font-color-general-950 mx-2", variantChip = 'large', trafficData, icon = null,
        iconBack = false, showCustomChip = false, showVerticalSeparator = false
    }
) => {
    const { t } = useTranslation();
    const statusId = getItemStatusFines(trafficData)
    return (
        <div className="d-flex justify-content-between align-items-center mb-2">
            <div className={'d-flex align-items-center'}>
                {iconBack &&
                    <div><IconLeftArrow
                        width={32}
                        height={32}
                        onClick={() => {
                            onHide();
                        }}
                    /></div>
                }
                {icon !== null && <>{icon}</>}
                <p className={classNameTitle}>
                    {t(title)}
                </p>
                {showVerticalSeparator && <div className='vertical-separator' />}

                {showCustomChip &&
                    <CustomChip
                        background={statusColor[statusId]}
                        fontColor={statusFontColor[statusId]}
                        borderColor={statusBorderColor[statusId]}
                        legend={t(status[statusId]) || EMPTY_VALUES.DEFAULT}
                        variant={variantChip}
                    />
                }
            </div>
            {onHide &&
            <div>
                <CloseModalIcon
                    width={12}
                    height={12}
                    onClick={() => {
                        onHide();
                    }}
                    className="icon-color-shades-400"
                />
            </div>
            }
        </div>
    );

}

export default ComponentHeaderBack
